import { render, staticRenderFns } from "./FavoritosMobile.vue?vue&type=template&id=b8aac65e&scoped=true&"
import script from "./FavoritosMobile.vue?vue&type=script&lang=js&"
export * from "./FavoritosMobile.vue?vue&type=script&lang=js&"
import style0 from "./FavoritosMobile.vue?vue&type=style&index=0&id=b8aac65e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aac65e",
  null
  
)

export default component.exports